import { useCallback } from 'react'
import { useActivitiesContext } from '../../../../context'
import { changeContentActionCreator } from '../../../../state'

export function useHandlers() {
  const [{ current }, dispatch] = useActivitiesContext()
  const handleBackClick = useCallback(() => {
    if (current) {
      dispatch(changeContentActionCreator('details'))
    } else {
      dispatch(changeContentActionCreator('list'))
    }
  }, [current, dispatch])

  return {
    handleBackClick,
  }
}
